import { render, staticRenderFns } from "./PdvDashboard.vue?vue&type=template&id=ed5aa81c&scoped=true"
import script from "./PdvDashboard.vue?vue&type=script&lang=js"
export * from "./PdvDashboard.vue?vue&type=script&lang=js"
import style0 from "./PdvDashboard.vue?vue&type=style&index=0&id=ed5aa81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5aa81c",
  null
  
)

export default component.exports